(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var topic = document.getElementById('ContactFormTopic');
    var field = document.getElementById('ContactOrderField');
    if (!topic || !field) return;
    function sync() {
      field.hidden = topic.value !== topic.getAttribute('data-order-topic');
    }
    topic.addEventListener('change', sync);
    sync();
  })();

  } catch(e) { console.error(e); }
})();
})();
